import { render, staticRenderFns } from "./lrImgSelect.vue?vue&type=template&id=4e5dcd10"
import script from "./lrImgSelect.vue?vue&type=script&lang=js"
export * from "./lrImgSelect.vue?vue&type=script&lang=js"
import style0 from "./lrImgSelect.vue?vue&type=style&index=0&id=4e5dcd10&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports